import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  fetchHomologacion,
  guardarAjusteDeHomologacion,
  type AjusteEditado,
} from "@/lib/homologacion";

export const HOMOLOGACION_KEY = ["homologacion"] as const;

/**
 * Los cinco ajustes con su escala.
 *
 * `staleTime` alto porque cambian cuando alguien los corrige desde el
 * mantenedor, no mientras se trabaja: la ficha del informe los consulta para
 * llenar cinco selectores por comparable, y sin esto los volvería a pedir en
 * cada montaje.
 */
export function useHomologacion() {
  return useQuery({
    queryKey: HOMOLOGACION_KEY,
    queryFn: fetchHomologacion,
    staleTime: 10 * 60 * 1000,
  });
}

export function useGuardarAjusteDeHomologacion() {
  const cliente = useQueryClient();

  return useMutation({
    mutationFn: ({ id, cambios }: { id: number; cambios: AjusteEditado }) =>
      guardarAjusteDeHomologacion(id, cambios),
    onSuccess: () => {
      cliente.invalidateQueries({ queryKey: HOMOLOGACION_KEY });
    },
  });
}
